/** @format */

import {styled} from '@mui/material/styles';
import {Typography} from '@mui/material';

const CommonTextStyle = styled(Typography)(() => ({
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
}));

export const HeadingText = styled(CommonTextStyle)(({theme}) => ({
  color: theme.palette.figma_surface?.light,
}));

export const RegularText = styled(CommonTextStyle)(({theme}) => ({
  color: theme.palette.figma_surface?.light,
  display: 'inline',
}));

export const BlueText = styled(CommonTextStyle)(({theme}) => ({
  color: theme.palette.figma_primary?.dark,
  display: 'inline',
}));

export const BlueTextDots = styled(CommonTextStyle)(({theme}) => ({
  color: theme.palette.figma_primary?.dark,
  textDecorationLine: 'underline',
  textDecorationStyle: 'dotted',
  textDecorationSkipInk: 'auto',
  textDecorationThickness: '10%',
  textUnderlineOffset: 'auto',
  textUnderlinePosition: 'from-font',
  display: 'inline',
  cursor: 'pointer',
}));
